<div *ngIf="docItems else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   (done)="onDeleteConfirmation($event)"
                                   *ngIf="confirmDeleteOn"
                                   ></app-confirm-delete-product-part>

  <app-income-price-breakdown-dialog #priceBreakdownDialog></app-income-price-breakdown-dialog>

  <p-table #docItemTable [value]="docItems"
           dataKey="DOCITEMID"
           [loading]="contentIsLoading"
           selectionMode="single"
           [(selection)]="sDI"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           editMode="row"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="caption" *ngIf="showHeader">
      <div class="grid mb-2">
        <div class="col-6">
          <div class="grid">
            <div class="col-8">
              <p-selectButton [options]="showDocRowsOptions" [(ngModel)]="showRowOptions"
                              multiple="multiple" optionLabel="name" optionValue="value" optionDisabled="disabled"
                              (onChange)="onRowsOptionChange($event)" styleClass="mr-2"
                              pTooltip="Показывать дополнительные поля документа" tooltipPosition="top">
              </p-selectButton>
            </div>
            <div class="col-2" style="margin: auto">

              <label class="mr-2" for="switch1">По памяти</label>
              <p-inputSwitch inputId="switch1" (onChange)="profitModeChange($event)" [(ngModel)]="profitMode" pTooltip="Включить расчет по 'памяти'" tooltipPosition="top"></p-inputSwitch>
            </div>

            <div class="col-2" style="margin: auto">
              <label class="mr-2" for="switch2">Включать пустые строки</label>
              <p-inputSwitch inputId="switch2" (onChange)="countEmptyModeChange($event)" [(ngModel)]="countEmpty" [disabled]="editMode" pTooltip="Учитывать позиции с нулевым количеством" tooltipPosition="top"></p-inputSwitch>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="grid mt-2 justify-content-end">
            <p-splitButton [label]="bulkDiscountLabel" icon="pi pi-percentage" [model]="items" styleClass="p-button-success hide-label mr-2"
                           [disabled]="noItems || editMode" (onDropdownClick)="checkCommand($event)" (onClick)="doSetDiscount( 'client')"
                           [pTooltip]="bulkDiscountTierTooltip" tooltipPosition="top"></p-splitButton>

            <p-inputNumber [(ngModel)]="u4etkaMultiplier" class="mr-1" prefix="Разделить на " [showButtons]="true" mode="decimal" [minFractionDigits]="2" [step]="0.01" [min]="0.5" [max]="1.5" *ngIf="canSeeU4etka"></p-inputNumber>
            <p-button icon="pi pi-briefcase" styleClass="p-button-success mr-2" (onClick)="updU4etkaPrice($event)" [disabled]="editMode"
                      pTooltip="Заполнить учетку" tooltipPosition="top" *ngIf="canSeeU4etka"></p-button>
            <p-button icon="pi pi-check-square" styleClass="p-button-danger mr-2" (onClick)="updU4etkaRefresh($event)" [disabled]="editMode"
                      pTooltip="Обновить учетку по оплате" tooltipPosition="top" *ngIf="canSeeU4etka"></p-button>
            <p-button icon="pi pi-trash" styleClass="p-button-secondary mr-2" [disabled]="noItems || editMode" (onClick)="clearU4etkaValue($event)"
                      pTooltip="Очистить поле учетки" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-euro" styleClass="p-button-success mr-2" [disabled]="noItems || editMode" (onClick)="updMainPrice($event)"
                      pTooltip="Обновить цену в гривне (основной валюте)" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-dollar" styleClass="p-button-success mr-2" [disabled]="noItems || editMode" (onClick)="updCurrPrice($event)"
                      pTooltip="Обновить валютную цену" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-save" (onClick)="onSaveRows($event)" styleClass="p-button-success mr-2" [disabled]="!changes || editMode"
                      pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-undo" (onClick)="onUndoRows($event)" styleClass="p-button-warning mr-4" [disabled]="!changes || editMode"
                      pTooltip="Отменить изменения в цене" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-sort" styleClass="p-button-secondary mr-4 hide-label" [disabled]="noItems || editMode" (onClick)="cleanSortMode($event)"
                      pTooltip="Убрать сортировку" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-sort-numeric-down" styleClass="p-button-success mr-2" [disabled]="noItems || editMode" (onClick)="updateRowIndexes($event)"
                      pTooltip="Обновить индексы строк в документе" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-refresh" styleClass="p-button-success ml-2 mr-2" [disabled]="editMode" (onClick)="reloadDocContent($event)"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>

            <p-splitButton label="XLSX" icon="pi pi-file-excel" [model]="excelExportItems" styleClass="p-button-info hide-label mr-2"
                           [disabled]="exportDisabled" (onDropdownClick)="checkCommand($event)" (onClick)="onExportData()"
                           pTooltip="Экспортировать содержимое документа" tooltipPosition="top"></p-splitButton>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="allowTopButtons && allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRowOnTop($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>

            <p-button label="Вставить выше" icon="pi pi-chevron-up" (onClick)="onAddRowAbove($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="noAddAbove"
                      pTooltip="Добавить новую строку выше" tooltipPosition="top"></p-button>
            <p-button label="Вставить ниже" icon="pi pi-chevron-down" (onClick)="onAddRowBelow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="noAddBelow"
                      pTooltip="Добавить новую строку ниже" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2 hide-label" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2 hide-label" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn style="width: 5rem !important; padding:0px;" *ngIf="allowEditControls">
          <p-selectButton [options]="showFilterOptions" [(ngModel)]="showFilterValue" multiple="multiple" optionValue="value" optionDisabled="disabled" optionLabel="icon"
                          pTooltip="Показывать фильтр по полям таблицы" tooltipPosition="top">
            <ng-template let-item pTemplate>
              <i [class]="item.icon"></i>
            </ng-template>
          </p-selectButton>
        </th>
        <th pResizableColumn pSortableColumn="PRODCODE" style="width:15% !important">Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODCUSTCODE" style="width: 8rem !important" *ngIf="seeTariffCode">Код УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODBARCODEMASK" style="width: 8rem !important" *ngIf="seeTariffCode">EAN/UPC <p-sortIcon field="PRODBARCODEMASK"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRODNAME" style="width: auto !important">Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMTEXT1" style="width: auto !important" *ngIf="seeDiNote">Примечание <p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMTEXT2" style="width: 6rem !important" *ngIf="seeDiNote">Состав <p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMQTY" style="width: 5rem !important">Кол-во <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSHIPPED" style="width: 5rem !important" *ngIf="showShipped">Отг-но <p-sortIcon field="DOCITEMSHIPPED"></p-sortIcon></th>
        <!--<th pResizableColumn pSortableColumn="prodInfo.PRODSTOCK" style="width: 5rem !important" *ngIf="!editMode">Склад <p-sortIcon field="prodInfo.PRODSTOCK"></p-sortIcon></th>-->
        <th pResizableColumn pSortableColumn="prodInfo.PRODSTOCK" style="width: 5rem !important">Склад <p-sortIcon field="prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODRESERVE" style="width: 5rem !important" *ngIf="!editMode && seeReservation">Резерв <p-sortIcon field="prodInfo.PRODRESERVE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODSOLD" style="width: 5rem !important" *ngIf="!editMode && seeReservation">Продано <p-sortIcon field="prodInfo.PRODSOLD"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODONWAY" style="width: 5rem !important" *ngIf="!editMode && seeReservation">В пути <p-sortIcon field="prodInfo.PRODONWAY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DISCOUNT" style="width: 6rem !important">Скидка <p-sortIcon field="DISCOUNT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMVPRICE" style="width: 7rem !important">Цена $ <p-sortIcon field="DOCITEMVPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRICEWOVAT" style="width: 8rem !important" *ngIf="seeWoVAT">Цена без НДС <p-sortIcon field="DOCITEMPRICEWOVAT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRICE" style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="U4ETKA" style="width: 8rem !important" *ngIf="canSeeU4etka">Учетка <p-sortIcon field="U4ETKA"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCINCOMEPRICE" style="width: 8rem !important" *ngIf="seeProfit">Входная <p-sortIcon field="DOCINCOMEPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPROFIT" style="width: 8rem !important" *ngIf="seeProfit">Доход <p-sortIcon field="DOCITEMPROFIT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMVSUM" style="width: 8rem !important">Сумма $ <p-sortIcon field="DOCITEMVSUM"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSUMWOVAT" style="width: 8rem !important" *ngIf="seeWoVAT">Сумма без НДС <p-sortIcon field="DOCITEMSUMWOVAT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSUM" style="width: 8rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSUMU4" style="width: 8rem !important" *ngIf="canSeeU4etka">Сумма U4 <p-sortIcon field="DOCITEMSUMU4"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPROFITSUM" style="width: 8rem !important" *ngIf="seeProfit">Сумма дох <p-sortIcon field="DOCITEMPROFITSUM"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PAYITEMCLIID" style="width: 6rem !important"># <p-sortIcon field="PAYITEMCLIID"></p-sortIcon></th>
        <th style="width: 3rem !important"></th>
      </tr>

      <tr *ngIf="showFilter">
        <th pResizableColumn *ngIf="allowEditControls">=></th>

        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['PRODCODE']" [class.hasvalue]="cf3['PRODCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeTariffCode"><input pInputText type="text" [(ngModel)]="cf3['PRODCUSTCODE']" [class.hasvalue]="cf3['PRODCUSTCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCUSTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeTariffCode"><input pInputText type="text" [(ngModel)]="cf3['PRODBARCODEMASK']" [class.hasvalue]="cf3['PRODBARCODEMASK']" (input)="docItemTable.filter($event.target.value, 'PRODBARCODEMASK', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRODNAME']" [class.hasvalue]="cf3['DOCITEMPRODNAME']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeDiNote"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT1']" [class.hasvalue]="cf3['DOCITEMTEXT1']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeDiNote"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT2']" [class.hasvalue]="cf3['DOCITEMTEXT2']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMQTY']" [class.hasvalue]="cf3['DOCITEMQTY']" (input)="docItemTable.filter($event.target.value, 'DOCITEMQTY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="showShipped"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSHIPPED']" [class.hasvalue]="cf3['DOCITEMSHIPPED']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSHIPPED', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <!--<th pResizableColumn *ngIf="!editMode "><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSTOCK']" [class.hasvalue]="cf3['PRODSTOCK']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>-->
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSTOCK']" [class.hasvalue]="cf3['PRODSTOCK']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODRESERVE']" [class.hasvalue]="cf3['PRODRESERVE']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODRESERVE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSOLD']" [class.hasvalue]="cf3['PRODSOLD']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSOLD', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODONWAY']" [class.hasvalue]="cf3['PRODONWAY']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODONWAY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DISCOUNT']" [class.hasvalue]="cf3['DISCOUNT']" (input)="docItemTable.filter($event.target.value, 'DISCOUNT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVPRICE']" [class.hasvalue]="cf3['DOCITEMVPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeWoVAT"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRICEWOVAT']" [class.hasvalue]="cf3['DOCITEMPRICEWOVAT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRICEWOVAT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRICE']" [class.hasvalue]="cf3['DOCITEMPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="canSeeU4etka"><input pInputText type="text" [(ngModel)]="cf3['U4ETKA']" [class.hasvalue]="cf3['U4ETKA']" (input)="docItemTable.filter($event.target.value, 'U4ETKA', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeProfit"><input pInputText type="text" [(ngModel)]="cf3['DOCINCOMEPRICE']" [class.hasvalue]="cf3['DOCINCOMEPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCINCOMEPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeProfit"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPROFIT']" [class.hasvalue]="cf3['DOCITEMPROFIT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPROFIT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVSUM']" [class.hasvalue]="cf3['DOCITEMVSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeWoVAT"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUMWOVAT']" [class.hasvalue]="cf3['DOCITEMSUMWOVAT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUMWOVAT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUM']" [class.hasvalue]="cf3['DOCITEMSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="canSeeU4etka"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUMU4']" [class.hasvalue]="cf3['DOCITEMSUMU4']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUMU4', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeProfit"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPROFITSUM']" [class.hasvalue]="cf3['DOCITEMPROFITSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPROFITSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn ><input pInputText type="text" [(ngModel)]="cf3['PAYITEMCLIID']" [class.hasvalue]="cf3['PAYITEMCLIID']" (input)="docItemTable.filter($event.target.value, 'PAYITEMCLIID', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th pResizableColumn style="width: 3rem">...</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-docItem let-editing="editing" let-ri="rowIndex">
      <!--  -->
      <tr *ngIf="isDocItemRowVisible(docItem, editing)" [pEditableRow]="docItem" [pSelectableRow]="docItem" >

        <td *ngIf="allowEditControls">
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(docItem)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" [disabled]="!allowSave(docItem)" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(docItem)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(docItem, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="overflow: visible !important; padding-right:3px">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-productselector [showLabel]="false" [searchText]="docItem.PRODCODE" [allowOld]="allowOld" (selectedProduct)="onProductSelection($event, docItem)" [style]="{'width':'60%'}"></app-productselector>
            </ng-template>
            <ng-template pTemplate="output">
              <a [routerLink]="['/edit-product', docItem.PRODID]">{{docItem.PRODCODE}}</a>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="background-color:ghostwhite" *ngIf="seeTariffCode"><span [class.redvalue]="docItem.nta" [class.greencolour]="!docItem.nta">{{docItem.PRODCUSTCODE}}</span></td>
        <td style="background-color:ghostwhite" *ngIf="seeTariffCode">{{docItem.PRODBARCODEMASK}}</td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMPRODNAME}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeDiNote">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMTEXT1" [style]="{'width':'100%'}"
                     pTooltip="Срок поставки и другие примечания" tooltipPosition="top" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMTEXT1" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMTEXT1}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeDiNote">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="yesno" [(ngModel)]="docItem.DOCITEMTEXT2" 
                          pTooltip="Разворачивать состав изделия при печати" tooltipPosition="top"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">{{docItem.DOCITEMTEXT2}}</ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMQTY" [style]="{'width':'100%'}" step="1" style="text-align: right"
                     (input)="onDOCITEMQTYChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <span [class.shipped]="docItem.sha" [class.missed]="docItem.mst">{{docItem.DOCITEMQTY | number:'1.0-2'}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right; background-color:ghostwhite" *ngIf="showShipped">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{docItem.DOCITEMSHIPPED | number:'1.0-2'}}
          </span>
        </td>

        <!--<td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode">-->
        <td style="text-align: right; background-color:ghostwhite">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODRESERVE | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODSOLD | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODONWAY | number:'1.0-2' }}
          </span>
          <ng-template #waiting>
            <span>---</span>
          </ng-template>
        </td>

        <td style="overflow: visible !important;text-align: right"
            [class.discount-too-big]="docItem.bmd"
            [class.min-discount]="docItem.dmi"
            [class.med-discount]="docItem.dme"
            [class.max-discount]="docItem.dma">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="docItem.doptions" [ngModel]="docItem.DISCOUNT | number:'1.0-0'" editable="true"
                          [pTooltip]="discountTierTooltip(docItem)" tooltipPosition="top" (onChange)="setDiscount($event, docItem)" (keydown)="$event.stopPropagation()"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <span>{{docItem.DISCOUNT | number:'1.1-1'}}%</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" [class.missed]="docItem.cpn" [class.curr-not-match]="docItem.cnm" [class.below-income]="docItem.bip">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMVPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMVPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMVPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" *ngIf="seeWoVAT">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMPRICEWOVAT" [style]="{'width':'100%'}" step="0.1" style="text-align: right"
                     (change)="onDOCITEMPRICEWOVATChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMPRICEWOVAT | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" [class.missed]="docItem.cpn" [class.rate-not-match]="docItem.rnm" [class.below-income]="docItem.bip">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" *ngIf="canSeeU4etka">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.U4ETKA" [style]="{'width':'100%'}" step="0.01" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.U4ETKA | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right; background-color:ghostwhite" *ngIf="seeProfit">
          <a href="javascript:void(0)" class="income-price-cell-link" title="Показати структуру ціни"
             (click)="openIncomePriceBreakdown(docItem)">{{docItem.DOCINCOMEPRICE | number:'1.2-2' }}</a>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="seeProfit" [class.below-income]="docItem.lpf">{{docItem.DOCITEMPROFIT | number:'1.2-2' }}</td>

        <td style="text-align: right; background-color:ghostwhite">{{docItem.DOCITEMVSUM | number:'1.2-2' }}</td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="seeWoVAT">{{docItem.DOCITEMSUMWOVAT | number:'1.2-2' }}</td>
        <td style="text-align: right; background-color:ghostwhite">{{docItem.DOCITEMSUM | number:'1.2-2' }}</td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="canSeeU4etka">{{docItem.DOCITEMSUMU4 | number:'1.2-2' }}</td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="seeProfit" [class.below-income]="docItem.lpf">{{docItem.DOCITEMPROFITSUM | number:'1.2-2' }}</td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.PAYITEMCLIID" [style]="{'width':'100%'}" min="0" step="10" style="text-align: right" (change)="onPAYITEMCLIIDChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{docItem.PAYITEMCLIID | number:'1.0-0'}}</ng-template>
          </p-cellEditor>
        </td>

        <td>
          <button *ngIf="!docItem.hlt" pButton pRipple type="button" icon="pi pi-check" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-success p-button-text"></button>
          <button *ngIf="docItem.hlt" pButton pRipple type="button" icon="pi pi-exclamation-triangle" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-danger p-button-text"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="inputDocument as doc">
      <tr>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" *ngIf="allowEditControls">{{doc.DOCITEMS | number:'1.0-2'}}</td>
        <td></td>
        <td></td>
        <td *ngIf="seeTariffCode"></td>
        <td *ngIf="seeTariffCode"></td>
        <td *ngIf="seeDiNote"></td>
        <td *ngIf="seeDiNote"></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCTOTALITEMS | number:'1.0-2'}}</td>
        <td *ngIf="showShipped"></td>
        <!--<td *ngIf="!editMode"></td>-->
        <td ></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td></td>
        <td></td>
        <td *ngIf="seeWoVAT"></td>
        <td></td>
        <td *ngIf="canSeeU4etka"></td>
        <td *ngIf="seeProfit"></td>
        <td *ngIf="seeProfit"></td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{doc.DOCVSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="seeWoVAT">{{doc.DOCSUMWOVAT | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{doc.DOCSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="canSeeU4etka">{{doc.DOCSUMU4ETKA | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="seeProfit">{{doc.DOCSUMPROFIT | number:'1.2-2' }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right"></td>
        <td></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid mt-2" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>

            <p-button label="Вставить выше" icon="pi pi-chevron-up" (onClick)="onAddRowAbove($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="noAddAbove"
                      pTooltip="Добавить новую строку выше" tooltipPosition="top"></p-button>
            <p-button label="Вставить ниже" icon="pi pi-chevron-down" (onClick)="onAddRowBelow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="noAddBelow"
                      pTooltip="Добавить новую строку ниже" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2 hide-label" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2 hide-label" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>

      <div class="fluid formgrid grid" *ngIf="inputDocument as doc">
        <div class="field col-1 xl:col-1 sm:col-4">
          <label for="DS1" class="do-not-wrap-text">Количество позиций</label>
          <p-inputNumber id="DS1" [(ngModel)]="doc.DOCITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4">
          <label for="DS2" class="do-not-wrap-text">Общее количество</label>
          <p-inputNumber id="DS2" [(ngModel)]="doc.DOCTOTALITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4" *ngIf="canSeeU4etka">
          <label for="DS3" class="do-not-wrap-text">Сумма учетки</label>
          <p-inputNumber id="DS3" [(ngModel)]="doc.DOCSUMU4ETKA" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4">
          <label for="DS4" class="do-not-wrap-text">Сумма в валюте</label>
          <p-inputNumber id="DS4" [(ngModel)]="doc.DOCVSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4" *ngIf="seeWoVAT">
          <label for="DS5" class="do-not-wrap-text">Сумма без НДС</label>
          <p-inputNumber id="DS5" [(ngModel)]="doc.DOCSUMWOVAT" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4">
          <label for="DS6" class="do-not-wrap-text">НДС</label>
          <p-inputNumber id="DS6" [(ngModel)]="doc.DOCVAT" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4">
          <label for="DS7" class="do-not-wrap-text">Сумма с НДС</label>
          <p-inputNumber id="DS7" [(ngModel)]="doc.DOCSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4" *ngIf="showPaysum">
          <label for="DS8" class="do-not-wrap-text">Оплачено в валюте</label>
          <p-inputNumber id="DS8" [(ngModel)]="doc.DOCPAIDSUMVAL" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4" *ngIf="showPaysum">
          <label for="DS9" class="do-not-wrap-text">Оплачено</label>
          <p-inputNumber id="DS9" [(ngModel)]="doc.DOCPAIDSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-1 xl:col-1 sm:col-4" *ngIf="showPaysum">
          <label for="DS0" class="do-not-wrap-text">Отгружено</label>
          <p-inputNumber id="DS0" [(ngModel)]="doc.DOCSHIPSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="21">Пустой документ</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Содержимое документа загружается...</p>
</ng-template>
